module.exports = __webpack_public_path__ + "img/amuebla-logo.fdec1901.png";